module.exports = __webpack_public_path__ + "static/media/windows_overlay-fs8.29c76a05.png";